import { THEMES_SET_PREVIEW_ID } from 'store/themes';

export function setPreviewThemeId(previewThemeId) {
  return {
    type: THEMES_SET_PREVIEW_ID,
    payload: {
      previewThemeId,
    },
  };
}
